module.exports = __webpack_public_path__ + "img/img-5.f6b2924.jpg";